import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgCheckFill({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.84 17.532a6.35 6.35 0 0 1 4.121 5.949 6.35 6.35 0 0 1-4.122 5.948 6.352 6.352 0 0 1-8.41 8.41 6.35 6.35 0 0 1-5.948 4.123 6.36 6.36 0 0 1-5.949-4.123 6.348 6.348 0 0 1-7.118-1.292c-1.927-1.92-2.353-4.779-1.292-7.118A6.35 6.35 0 0 1 6 23.481a6.35 6.35 0 0 1 4.122-5.949 6.352 6.352 0 0 1 1.292-7.118c1.92-1.927 4.78-2.353 7.118-1.292A6.35 6.35 0 0 1 24.481 5a6.35 6.35 0 0 1 5.948 4.122 6.352 6.352 0 0 1 8.41 8.41Zm-5.71 1.455a1.5 1.5 0 1 0-2.26-1.974L21.833 27.36l-2.666-3.302a1.5 1.5 0 0 0-2.334 1.884l2.829 3.504a2.747 2.747 0 0 0 2.211 1.055 2.745 2.745 0 0 0 2.138-1.075l9.119-10.438Z"
                fill="#297A71"
            />
        </svg>
    )
}
SvgCheckFill.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgCheckFill
